<app-common-header></app-common-header>
<div class="body">
  <div class="mainContent">
    <div class="create-question">
      <div class="create-question__preview-box__container" id="preview-box">
        <div class="create-question__preview-box__container--space"></div>
        <div class="create-question__preview-box">
          <span class="create-question__preview-box__head"
            ><span> Question Preview </span>
            <span class="create-question__preview-box__head--right-block">
              <span
                class="create-question__preview-box__head--right-block--button"
                (click)="loadTikZ()"
                *ngIf="tikzExists"
                >Preview Images</span
              >
              <span
                class="create-question__preview-box__head--right-block--button create-question__preview-box__head--right-block--button--copy"
                [ngClass]="{
                  'create-question__preview-box__head--right-block--button--active':
                    saveQuestionClicked
                }"
                *ngIf="!isCreateQuestion"
                (click)="saveQuestion(true)"
                >Save As Copy</span
              >
              <span
                class="create-question__preview-box__head--right-block--button"
                [ngClass]="{
                  'create-question__preview-box__head--right-block--button--active':
                    saveQuestionClicked
                }"
                (click)="saveQuestion(false)"
                >Save Question</span
              >
            </span>
          </span>
          <!-- Preview for Questions -->
          <div
            class="create-question__preview-box__body"
            [ngClass]="{
              'create-question__preview-box__body--two-columns':
                selectedDisplayStyle === 2 && selectedQuestionType === 1
            }"
          >
            <div class="display-grid fw-500">
              <div
                *ngFor="let content of questionArray; let index = index"
                [ngClass]="{
                  'create-question__preview-box--tikz': content.type == 'TikZ'
                }"
              >
                <app-multi-data
                  [multiData]="{
                    type: content.type,
                    data: content.data,
                    tikzId: 'tikzOutput' + index,
                    imageKeys: content.images || [],
                    listOfImages: images
                  }"
                ></app-multi-data>
              </div>
            </div>
            <!-- ** Preview for Options -->
            <div class="display-grid fw-500" *ngIf="selectedQuestionType === 1">
              <div
                *ngFor="let option of optionArray; let optionIndex = index"
                class="create-question__preview-box__options"
              >
                <span
                  *ngIf="option.length > 0"
                  class="create-question__preview-box__options--label"
                  >{{ optionsText[optionIndex] }})</span
                >
                <div>
                  <div *ngFor="let content of option; let index = index">
                    <app-multi-data
                      [multiData]="{
                        type: content.type,
                        data: content.data,
                        tikzId:
                          'tikzOutput-option-' + optionIndex + '-' + index,
                        imageKeys: content.images || [],
                        listOfImages: images
                      }"
                    ></app-multi-data>
                  </div>
                </div>
              </div>
            </div>
            <!-- ** Preview for Explanations -->
            <div class="display-grid fw-500 pt-2">
              <div
                [ngClass]="{
                  'pb-1': selectedQuestionType === 2
                }"
              >
                <b>Explanations</b>
              </div>
              <div *ngIf="selectedQuestionType === 1">
                <div
                  *ngFor="
                    let option of optionExplanations;
                    let optionIndex = index
                  "
                  [ngClass]="{
                    'd-none': !(option.length > 0) && selectedQuestionType === 1
                  }"
                >
                  <span
                    *ngIf="option.length > 0"
                    class="create-question__preview-box__options--label"
                    ><b
                      >Option {{ optionsText[optionIndex] }} Explanation
                    </b></span
                  >
                  <div class="pt-1">
                    <div *ngFor="let content of option; let index = index">
                      <app-multi-data
                        [multiData]="{
                          type: content.type,
                          data: content.data,
                          tikzId:
                            'tikzOutput-optionExplanation-' +
                            optionIndex +
                            '-' +
                            index,
                          imageKeys: content.images || [],
                          listOfImages: images
                        }"
                      ></app-multi-data>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="selectedQuestionType === 2" class="d-flex g-1">
                <div
                  *ngFor="
                    let option of gridinExplanations;
                    let optionIndex = index
                  "
                >
                  <span class="create-question__preview-box__options--label"
                    >{{ optionIndex + 1 }})</span
                  >
                  <div>
                    <app-multi-data
                      [multiData]="{
                        type: option.type,
                        data: option.data,
                        tikzId: 'tikzOutput-freetextExplanation-' + optionIndex,
                        imageKeys: option.images || [],
                        listOfImages: images
                      }"
                    ></app-multi-data>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="create-question__preview-box__container--space"></div>
      </div>
      <div
        class="create-question__create-box"
        [ngStyle]="calculateMargin()"
        id="create-box"
      >
        <div class="create-question__create-box__sidebar">
          <div class="create-question__create-box__sidebar__header">
            <span
              (click)="selectedTab = 1"
              class="create-question__create-box__sidebar__header__item"
              [ngClass]="{
                'create-question__create-box__sidebar__header__item--active':
                  selectedTab === 1
              }"
            >
              Questions
            </span>
            <span
              (click)="selectedTab = 2"
              class="create-question__create-box__sidebar__header__item"
              [ngClass]="{
                'create-question__create-box__sidebar__header__item--active':
                  selectedTab === 2
              }"
            >
              {{ selectedQuestionType === 1 ? "Options" : "Answers" }}
            </span>
            <span
              (click)="selectedTab = 3"
              class="create-question__create-box__sidebar__header__item"
              [ngClass]="{
                'create-question__create-box__sidebar__header__item--active':
                  selectedTab === 3
              }"
            >
              Attached to
            </span>
          </div>
          <div class="create-question__create-box__sidebar__body">
            <div class="create-question__actions">
              <span
                class="create-question__text-button"
                (click)="
                  selectedTab === 1
                    ? toggleOverlay(codeTypeOverlay, $event, 'question')
                    : selectedTab === 2 && selectedQuestionType === 1
                      ? toggleOverlay(codeTypeOverlay, $event, 'option')
                      : selectedTab === 2 && selectedQuestionType === 2
                        ? addGridin()
                        : addCourses()
                "
              >
                <mat-icon>add</mat-icon>
                <span>Add</span>
              </span>
              <span
                class="create-question__text-button"
                (click)="selectedTab = 4"
              >
                <mat-icon>upload</mat-icon>
                <span>Video</span>
              </span>
            </div>
            <div class="create-question__create-box__sidebar__body__grid">
              <mat-label
                class="create-question__create-box__sidebar__body__grid--label"
                >Question Type</mat-label
              >
              <mat-select
                [(ngModel)]="selectedQuestionType"
                [disabled]="!isCreateQuestion"
              >
                <mat-option [value]="1">MCQ</mat-option>
                <mat-option [value]="2">Free response</mat-option>
              </mat-select>
            </div>
            <div class="create-question__create-box__sidebar__body__grid">
              <mat-label
                class="create-question__create-box__sidebar__body__grid--label"
                >Status</mat-label
              >
              <mat-select [(ngModel)]="status">
                <mat-option [value]="1">Final</mat-option>
                <mat-option [value]="0">Delete</mat-option>
                <mat-option [value]="2">Private</mat-option>
              </mat-select>
            </div>
            <div
              *ngIf="selectedQuestionType === 1"
              class="create-question__create-box__sidebar__body__grid"
            >
              <mat-label
                class="create-question__create-box__sidebar__body__grid--label"
                >Display Style</mat-label
              >
              <mat-select [(ngModel)]="selectedDisplayStyle">
                <mat-option [value]="1">List View</mat-option>
                <mat-option [value]="2">Side View</mat-option>
              </mat-select>
            </div>
            <mat-form-field class="example-chip-list">
              <mat-chip-list #tagList aria-label="Fruit selection">
                <mat-chip
                  class="create-question__create-box__sidebar__body__tags"
                  *ngFor="let tag of tags; let tagIndex = index"
                  [removable]="true"
                  (removed)="removeTag(tagIndex)"
                >
                  {{ tag }}
                  <mat-icon
                    class="create-question__create-box__sidebar__body__tags--remove"
                    matChipRemove
                    >cancel</mat-icon
                  >
                </mat-chip>
                <input
                  placeholder="Tags"
                  [matChipInputFor]="tagList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="true"
                  (matChipInputTokenEnd)="addTag($event)"
                />
              </mat-chip-list>
            </mat-form-field>
          </div>
        </div>
        <div
          class="create-question__create-box__body"
          [ngClass]="{
            'create-question__error--border': errorExists
          }"
        >
          <!-- Question text boxes -->
          <ng-container *ngIf="selectedTab === 1">
            <app-create-multi-data
              *ngFor="let question of questionArray; let questionIndex = index"
              [createMultiData]="{
                multiData: question,
                error: errorExists
              }"
              (toggleAccordion)="toggleAccordion(questionIndex, questionArray)"
              (confirmDelete)="confirmDelete(questionIndex, 'question', $event)"
              (uploadImage)="uploadImage($event, questionIndex, questionArray)"
            ></app-create-multi-data>
          </ng-container>

          <!-- Option text boxes -->
          <ng-container *ngIf="selectedTab === 2 && selectedQuestionType === 1">
            <div class="create-question__create-box__body__options">
              <ng-container
                *ngFor="let option of optionArray; let optionIndex = index"
              >
                <p-radioButton
                  name="groupname"
                  [value]="optionIndex + 1"
                  [(ngModel)]="defaultAnswer"
                ></p-radioButton>
                <span
                  class="create-question__create-box__body__options__option"
                  [ngClass]="{
                    'create-question__create-box__body__options__option--enabled':
                      selectedOption == optionIndex
                  }"
                  (click)="selectedOption = optionIndex"
                >
                  <mat-icon
                    class="create-question__close"
                    *ngIf="optionIndex >= 2"
                    (click)="removeOption(optionIndex)"
                    >cancel</mat-icon
                  >
                  Option {{ optionsText[optionIndex] }}</span
                >
              </ng-container>
              <span
                *ngIf="optionArray.length < 10"
                class="create-question__create-box__body__options__option"
                (click)="addOption()"
                >Add Option</span
              >
            </div>
            <!-- <div
              *ngFor="
                let data of optionArray[selectedOption!];
                let index = index
              "
              class="create-question__create-box__body__textarea-box"
              [ngClass]="{
                'create-question__error--border':
                  errorExists && data.data === '' && selectedQuestionType === 1
              }"
            >
              <div
                class="create-question__create-box__body__textarea-box__head"
              >
                <span
                  (click)="toggleAccordion(index, optionArray[selectedOption!])"
                  class="create-question__create-box__body__textarea-box__head__type"
                  >{{ data.type }}
                  <mat-icon>{{
                    data.hidden ? "arrow_drop_up" : "arrow_drop_down"
                  }}</mat-icon></span
                >
                <img
                  (click)="confirmDelete(index, 'option')"
                  src="assets/crossbutton.png"
                  class="create-question__create-box__body__textarea-box__head__icon"
                />
              </div>
              <textarea
                *ngIf="!data.hidden"
                [id]="'option-' + selectedOption + '-' + index"
                class="create-question__create-box__body__textarea-box__textarea"
                [(ngModel)]="data.data"
              ></textarea>
            </div> -->
            <app-create-multi-data
              *ngFor="
                let option of optionArray[selectedOption!];
                let optionIndex = index
              "
              [createMultiData]="{
                multiData: option,
                error: errorExists
              }"
              (toggleAccordion)="
                toggleAccordion(optionIndex, optionArray[selectedOption!])
              "
              (confirmDelete)="confirmDelete(optionIndex, 'option', $event)"
              (uploadImage)="
                uploadImage($event, optionIndex, optionArray[selectedOption!])
              "
            ></app-create-multi-data>
            <span class="mt-10 fw-500">
              Option {{ optionsText[selectedOption!] }} Explanation
            </span>
            <span
              class="create-question__text-button"
              (click)="
                toggleOverlay(codeTypeOverlay, $event, 'optionExplanation')
              "
            >
              <mat-icon>add</mat-icon>
              <span>Add Explanation Text</span>
            </span>
            <!-- <div
              *ngFor="
                let explanation of optionExplanations[selectedOption!];
                let index = index
              "
              class="create-question__create-box__body__textarea-box"
            >
              <div
                class="create-question__create-box__body__textarea-box__head"
              >
                <span
                  (click)="
                    toggleAccordion(index, optionExplanations[selectedOption!])
                  "
                  class="create-question__create-box__body__textarea-box__head__type"
                  >{{ explanation.type }}
                  <mat-icon>{{
                    explanation.hidden ? "arrow_drop_up" : "arrow_drop_down"
                  }}</mat-icon></span
                >
                <img
                  (click)="confirmDelete(index, 'optionExplanation')"
                  src="assets/crossbutton.png"
                  class="create-question__create-box__body__textarea-box__head__icon"
                />
              </div>
              <textarea
                *ngIf="!explanation.hidden"
                [id]="'optionExplanation-' + selectedOption + '-' + index"
                class="create-question__create-box__body__textarea-box__textarea"
                [(ngModel)]="explanation.data"
              ></textarea>
            </div> -->
            <app-create-multi-data
              *ngFor="
                let explanation of optionExplanations[selectedOption!];
                let explanationIndex = index
              "
              [createMultiData]="{
                multiData: explanation,
                error: errorExists
              }"
              (toggleAccordion)="
                toggleAccordion(
                  explanationIndex,
                  optionExplanations[selectedOption!]
                )
              "
              (confirmDelete)="
                confirmDelete(explanationIndex, 'optionExplanation', $event)
              "
              (uploadImage)="
                uploadImage(
                  $event,
                  explanationIndex,
                  optionExplanations[selectedOption!]
                )
              "
            ></app-create-multi-data>
          </ng-container>

          <!-- Gridin Boxes -->
          <ng-container *ngIf="selectedTab === 2 && selectedQuestionType === 2">
            <div
              *ngFor="let gridin of gridinAnswers; let gridinIndex = index"
              class="create-question__create-box__body__textarea-box"
              [ngClass]="{
                'create-question__error--border':
                  errorExists && !gridin.data && selectedQuestionType === 2
              }"
            >
              <div
                class="create-question__create-box__body__textarea-box__head"
              >
                <span
                  (click)="toggleAccordion(gridinIndex, gridinAnswers)"
                  class="create-question__create-box__body__textarea-box__head__type"
                  >Answer {{ gridinIndex + 1 }}
                  <mat-icon>{{
                    gridin.hidden ? "arrow_drop_up" : "arrow_drop_down"
                  }}</mat-icon></span
                >
                <img
                  (click)="confirmDelete(gridinIndex, 'gridin', -1)"
                  src="assets/crossbutton.png"
                  class="create-question__create-box__body__textarea-box__head__icon"
                  *ngIf="gridinIndex > 0"
                />
              </div>
              <textarea
                *ngIf="!gridin.hidden"
                [id]="'answer-' + gridinIndex"
                class="create-question__create-box__body__textarea-box__textarea"
                [(ngModel)]="gridin.data"
              ></textarea>
            </div>
            <span class="mt-10 fw-500"> Answer Explanation </span>
            <span
              class="create-question__text-button"
              (click)="
                toggleOverlay(codeTypeOverlay, $event, 'gridinExplanation')
              "
            >
              <mat-icon>add</mat-icon>
              <span>Add Explanation Text</span>
            </span>
            <!-- <div
              *ngFor="let explanation of gridinExplanations; let index = index"
              class="create-question__create-box__body__textarea-box"
            >
              <div
                class="create-question__create-box__body__textarea-box__head"
              >
                <span
                  (click)="toggleAccordion(index, gridinExplanations)"
                  class="create-question__create-box__body__textarea-box__head__type"
                  >{{ explanation.type }}
                  <mat-icon>{{
                    explanation.hidden ? "arrow_drop_up" : "arrow_drop_down"
                  }}</mat-icon></span
                >
                <img
                  (click)="confirmDelete(index, 'gridinExplanation')"
                  src="assets/crossbutton.png"
                  class="create-question__create-box__body__textarea-box__head__icon"
                />
              </div>
              <textarea
                *ngIf="!explanation.hidden"
                [id]="'gridinExplanation-' + index"
                class="create-question__create-box__body__textarea-box__textarea"
                [(ngModel)]="explanation.data"
              ></textarea>
            </div> -->
            <app-create-multi-data
              *ngFor="
                let explanation of gridinExplanations;
                let explanationIndex = index
              "
              [createMultiData]="{
                multiData: explanation,
                error: errorExists
              }"
              (toggleAccordion)="
                toggleAccordion(explanationIndex, gridinExplanations)
              "
              (confirmDelete)="
                confirmDelete(explanationIndex, 'gridinExplanation', $event)
              "
              (uploadImage)="
                uploadImage($event, explanationIndex, gridinExplanations)
              "
            ></app-create-multi-data>
          </ng-container>

          <!-- Courses selection -->
          <ng-container *ngIf="selectedTab === 3">
            <div
              *ngFor="
                let selectedCourse of selectedCourses;
                let selectedCourseIndex = index
              "
              class="create-question__create-box__body__courses"
              [ngClass]="{
                'create-question__error--border':
                  attachedToError &&
                  (selectedCourse.courseId === null ||
                    selectedCourse.sectionId === null ||
                    selectedCourse.topicId === null ||
                    selectedCourse.subTopicId === null ||
                    selectedCourse.difficultyLevel === null),
                'create-question__create-box__body__courses--minimized':
                  selectedCourse.hidden
              }"
            >
              <div
                class="create-question__create-box__body__textarea-box__head"
              >
                <span
                  (click)="
                    toggleAccordion(selectedCourseIndex, selectedCourses)
                  "
                  class="create-question__create-box__body__textarea-box__head__type"
                  >Course {{ selectedCourseIndex + 1 }}
                  <mat-icon>{{
                    selectedCourse.hidden ? "arrow_drop_up" : "arrow_drop_down"
                  }}</mat-icon></span
                >
                <img
                  (click)="confirmDelete(selectedCourseIndex, 'course', -1)"
                  src="assets/crossbutton.png"
                  class="create-question__create-box__body__textarea-box__head__icon"
                />
              </div>
              <div
                *ngIf="selectedCourse.hidden"
                class="create-question__create-box__body__courses__course--name"
              >
                {{ getCourseName(selectedCourse) }}
              </div>
              <ng-container *ngIf="!selectedCourse.hidden">
                <div class="create-question__create-box__body__courses__course">
                  <mat-label
                    class="create-question__create-box__body__courses__course--label"
                    >Course</mat-label
                  >
                  <mat-select
                    [(ngModel)]="selectedCourse.courseId"
                    (selectionChange)="selectCourse(selectedCourseIndex)"
                    [ngClass]="{
                      'create-question__error--border':
                        attachedToError && selectedCourse.courseId === null
                    }"
                  >
                    <mat-option
                      *ngFor="let course of courses"
                      [value]="course.testTypeId"
                      >{{ course.testTypeName }}</mat-option
                    >
                  </mat-select>
                </div>
                <div class="create-question__create-box__body__courses__course">
                  <mat-label
                    class="create-question__create-box__body__courses__course--label"
                    >Section</mat-label
                  >
                  <mat-select
                    [ngClass]="{
                      'create-question__error--border':
                        attachedToError && selectedCourse.sectionId === null
                    }"
                    [(ngModel)]="selectedCourse.sectionId"
                    (selectionChange)="selectSection(selectedCourseIndex)"
                  >
                    <mat-option
                      *ngFor="let section of selectedCourse.sections"
                      [value]="section.test_section_type_id"
                      >{{ section.test_section }}</mat-option
                    >
                  </mat-select>
                </div>
                <div class="create-question__create-box__body__courses__course">
                  <mat-label
                    class="create-question__create-box__body__courses__course--label"
                    >Question Category</mat-label
                  >
                  <mat-select
                    [ngClass]="{
                      'create-question__error--border':
                        attachedToError && selectedCourse.sectionId === null
                    }"
                    [(ngModel)]="selectedCourse.questionCategory"
                  >
                    <mat-option
                      *ngFor="let category of questionCategories"
                      [value]="category.value"
                      >{{ category.label }}</mat-option
                    >
                  </mat-select>
                </div>
                <!-- <mat-checkbox
                  [(ngModel)]="selectedCourse.isTestQuestion"
                  class="create-question__create-box__body__courses__course--checkbox"
                >
                  Test Question
                </mat-checkbox> -->
                <div class="create-question__create-box__body__courses__course">
                  <mat-label
                    class="create-question__create-box__body__courses__course--label"
                    >Topic</mat-label
                  >
                  <mat-select
                    [ngClass]="{
                      'create-question__error--border':
                        attachedToError && selectedCourse.topicId === null
                    }"
                    [(ngModel)]="selectedCourse.topicId"
                    (selectionChange)="selectTopic(selectedCourseIndex)"
                  >
                    <mat-option
                      *ngFor="
                        let topic of selectedCourse.topics;
                        let topicIndex = index
                      "
                      [value]="topic.topic_id"
                      >{{ topic.topic_name }}</mat-option
                    >
                  </mat-select>
                </div>
                <div class="create-question__create-box__body__courses__course">
                  <mat-label
                    class="create-question__create-box__body__courses__course--label"
                    >Sub-Topic</mat-label
                  >
                  <mat-select
                    [(ngModel)]="selectedCourse.subTopicId"
                    [ngClass]="{
                      'create-question__error--border':
                        attachedToError && selectedCourse.subTopicId === null
                    }"
                  >
                    <mat-option
                      *ngFor="
                        let subTopic of selectedCourse.subTopics;
                        let subTopicIndex = index
                      "
                      [value]="subTopic.subtopic_id"
                      >{{ subTopic.subtopic_name }}</mat-option
                    >
                  </mat-select>
                </div>
                <div class="create-question__create-box__body__courses__course">
                  <mat-label
                    class="create-question__create-box__body__courses__course--label"
                    >Difficulty Level</mat-label
                  >
                  <mat-select
                    [(ngModel)]="selectedCourse.difficultyLevel"
                    [ngClass]="{
                      'create-question__error--border':
                        attachedToError &&
                        selectedCourse.difficultyLevel === null
                    }"
                  >
                    <mat-option
                      *ngFor="let level of difficultyLevels"
                      [value]="level.tdlId"
                      >{{ level.levelDescription }}</mat-option
                    >
                  </mat-select>
                </div>
              </ng-container>
            </div>
          </ng-container>
          <ng-container *ngIf="selectedTab === 4">
            <div class="video-header">
              <input
                type="file"
                #videoInput
                directory
                multiple
                accept="video/*"
                hidden
                (change)="onVideoFolderSelected($event)"
              />
              <button
                type="button"
                class="upload-btn"
                (click)="uploadVideos()"
                [disabled]="!selectedVideos.length"
              >
                Upload Videos
              </button>
              <button
                type="button"
                class="select-folder-btn"
                (click)="videoInput.click()"
              >
                Select Video
              </button>
            </div>
            <div *ngIf="isUploading" class="upload-progress">
              <p>Uploading videos... {{ uploadProgress }}%</p>
              <div class="progress-bar-container">
                <div
                  class="progress-bar-fill"
                  [style.width.%]="uploadProgress"
                ></div>
              </div>
            </div>
            <div>
              <div cdkDropListGroup>
                <div
                  cdkDropList
                  [cdkDropListData]="questionVideos"
                  (cdkDropListDropped)="drop($event)"
                  class="video-drop-container"
                >
                  <div
                    class="attached-video-item"
                    *ngFor="
                      let video of questionVideos;
                      let i = index;
                      trackBy: trackByVideo
                    "
                    cdkDrag
                  >
                    <div class="attached-video-left">
                      <div class="video-top-line">
                        <div class="video-name">{{ video.videoName }}</div>

                        <span
                          class="status-badge"
                          [ngClass]="video.isActive ? 'active' : 'inactive'"
                        >
                        </span>
                        <label class="switch">
                          <input
                            type="checkbox"
                            [(ngModel)]="video.isActive"
                            (change)="toggleVideoStatus(video, $event)"
                          />
                          <span class="slider"></span>
                        </label>
                      </div>
                      <div class="video-date">
                        <span>
                          {{ video.uploadTime | date: "MM-dd-yyyy hh:mm a" }}
                        </span>
                      </div>
                      <div class="video-uploaded-by">
                        <span>
                          {{ video.uploadedBy }}
                        </span>
                      </div>
                    </div>

                    <div
                      class="attached-video-right"
                      *ngIf="selectedVideoIndex === i; else showPlayBtn"
                    >
                      <span class="video-close-btn" (click)="closeVideo()"
                        >X</span
                      >
                      <iframe
                        [src]="selectedVideoUrl"
                        width="400"
                        height="300"
                        frameborder="0"
                        allowfullscreen
                        allow="autoplay; fullscreen; picture-in-picture"
                      ></iframe>
                    </div>
                    <ng-template #showPlayBtn>
                      <button (click)="playVideo(video, i)">Play</button>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
<p-overlayPanel #codeTypeOverlay [dismissable]="true">
  <div class="create-question__overlay">
    <span
      *ngFor="let codeType of codeTypes"
      class="create-question__overlay__options"
      (click)="addMultiData(codeType.type, codeTypeOverlay)"
      >{{ codeType.display }}</span
    >
  </div>
</p-overlayPanel>

<p-confirmDialog
  acceptButtonStyleClass="create-question__confirm__button"
  rejectButtonStyleClass="create-question__confirm__button"
  [style]="{ width: '25vw' }"
  styleClass="create-question__confirm"
>
  Content
</p-confirmDialog>
